<div id="subject-section" class="pb-20">
  <div class="container px-5">
    <h3 class="capitalize mb-10 font-bold  text-2xl text-center md:text-4xl lg:text-5xl">
      Why Students Trust Our Exam Questions
    </h3>

    <div class="flex flex-wrap justify-center gap-6">
      @for (sub of subjects; track $index) {
      <div class="w-full sm:w-[45%] md:w-[35%] lg:w-[35%]  xl:w-[30%]">
        <app-static-why-love [subject]="sub" />
      </div>
      }
    </div>
  </div>
</div>